<template>
  <v-container class="mb-4" v-if="fournisseur">
    <v-row justify="space-around">
      <v-card class="fournisseur" id="ficheFrn" style="min-width: 100%">
        <v-card-title class="justify-center white--text">
          <img
            :src="logoPath + fournisseur.id + '.svg'"
            alt=""
            style="max-width: 250px; max-height: 150px"
          />
          <img
            :src="logoPath + fournisseur.id + '.png'"
            alt=""
            style="max-width: 250px; max-height: 150px"
          />
          <img
            :src="logoPath + fournisseur.id + '.jpg'"
            alt=""
            style="max-width: 250px; max-height: 150px"
          />
          <img
            :src="logoPath + fournisseur.id + '.jpeg'"
            alt=""
            style="max-width: 250px; max-height: 150px"
          />
          <img
            :src="logoPath + fournisseur.id + '.gif'"
            alt=""
            style="max-width: 250px; max-height: 150px"
          />
          <span data-testid="nom">{{ fournisseur.nom }}</span>
        </v-card-title>
        <v-card-subtitle>
          <p class="white--text text-right">
            <v-icon color="white">mdi-calendar-sync</v-icon>&nbsp;
            <span data-testid="dateMaj">{{
              fournisseur.dateMaj | shortDateFr
            }}</span>
          </p>
        </v-card-subtitle>

        <v-expansion-panels
          v-model="panels"
          flat
          tile
          accordion
          multiple
          class="white--text"
        >
          <!-- Adresse siège -->
          <v-expansion-panel>
            <v-expansion-panel-header color="fournisseur" class="white--text">
              <v-row>
                <v-col>
                  <h3>Adresse siège</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <fournisseur-fiche-info
                icone="mdi-map-marker"
                etiquette="Adresse"
              >
                {{ fournisseur.adresseSiege.ligne1 }}
                <br v-if="fournisseur.adresseSiege.ligne1" />
                {{ fournisseur.adresseSiege.ligne2 }}
                <br v-if="fournisseur.adresseSiege.ligne2" />
                {{ fournisseur.adresseSiege.codePostal }}
                {{ fournisseur.adresseSiege.ville }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info etiquette="Téléphone" icone="mdi-phone">
                {{ fournisseur.adresseSiege.telephone }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info etiquette="Fax" icone="mdi-fax">
                {{ fournisseur.adresseSiege.fax }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info
                :link="fournisseur.adresseEmail"
                etiquette="Email"
                icone="mdi-at"
              >
                {{ fournisseur.adresseEmail }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info
                :link="fournisseur.urlSiteWeb"
                etiquette="Site Web"
                icone="mdi-web"
              >
                {{ fournisseur.urlSiteWeb }}
              </fournisseur-fiche-info>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Adresse commandes -->
          <v-expansion-panel>
            <v-expansion-panel-header color="fournisseur" class="white--text">
              <v-row>
                <v-col>
                  <h3 data-testid="adresseCommande">Adresse commandes</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <fournisseur-fiche-info
                etiquette="Adresse"
                icone="mdi-map-marker"
              >
                {{ fournisseur.adresseCommande.ligne1 }}
                <br v-if="fournisseur.adresseCommande.ligne1" />
                {{ fournisseur.adresseCommande.ligne2 }}
                <br v-if="fournisseur.adresseCommande.ligne2" />
                {{ fournisseur.adresseCommande.codePostal }}
                {{ fournisseur.adresseCommande.ville }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info etiquette="Téléphone" icone="mdi-phone">
                {{ fournisseur.adresseCommande.telephone }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info etiquette="Fax" icone="mdi-fax">
                {{ fournisseur.adresseCommande.fax }}
              </fournisseur-fiche-info>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Direction -->
          <v-expansion-panel>
            <v-expansion-panel-header color="fournisseur" class="white--text">
              <v-row>
                <v-col>
                  <h3 data-testid="direction">Direction</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <fournisseur-fiche-info
                etiquette="Direction générale"
                icone="mdi-home-account"
              >
                {{ fournisseur.directeurGeneral }}
              </fournisseur-fiche-info>

              <fournisseur-fiche-info
                etiquette="Direction commerciale"
                icone="mdi-briefcase-account"
              >
                {{ fournisseur.directeurCommercial }}
              </fournisseur-fiche-info>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Responsable matériovigilance -->
          <v-expansion-panel>
            <v-expansion-panel-header color="fournisseur" class="white--text">
              <v-row>
                <v-col>
                  <h3 data-testid="direction">Responsable Matériovigilance</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <fournisseur-fiche-info
                v-if="fournisseur.responsableMaterioVigilance"
                etiquette="Nom responsable"
                icone="mdi-shield-account"
              >
                {{ fournisseur.responsableMaterioVigilance.nom || null }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info
                etiquette="Téléphone"
                icone="mdi-phone"
                v-if="fournisseur.responsableMaterioVigilance"
              >
                {{ fournisseur.responsableMaterioVigilance.telephone || null }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info etiquette="Fax" icone="mdi-fax">
                <span v-if="fournisseur.responsableMaterioVigilance">
                  {{ fournisseur.responsableMaterioVigilance.fax || null }}
                </span>
              </fournisseur-fiche-info>
              <fournisseur-fiche-info
                v-if="fournisseur.responsableMaterioVigilance"
                etiquette="Email"
                icone="mdi-at"
                :link="fournisseur.responsableMaterioVigilance.adresseEmail"
              >
                {{
                  fournisseur.responsableMaterioVigilance.adresseEmail || null
                }}
              </fournisseur-fiche-info>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Certification -->
          <v-expansion-panel>
            <v-expansion-panel-header color="fournisseur" class="white--text">
              <v-row>
                <v-col>
                  <h3 data-testid="certification">Certification</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <fournisseur-fiche-info
                v-if="fournisseur.certification"
                etiquette="Certification"
                icone="mdi-certificate"
              >
                {{ fournisseur.certification.nom }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info
                v-if="fournisseur.certification"
                etiquette="Date certification"
                icone="mdi-calendar"
              >
                {{ fournisseur.certification.dateObtention | shortDateFr }}
              </fournisseur-fiche-info>
              <fournisseur-fiche-info
                v-if="fournisseur.certification"
                etiquette="Organisme"
                icone="mdi-shield-home"
              >
                {{ fournisseur.certification.organisme }}
              </fournisseur-fiche-info>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-row>
    <v-row class="justify-center">
      <v-col class="mt-4 my-2 text-center">
        <v-btn
          class="fournisseur white--text"
          :to="{ name: 'produits-fournisseur', params: { id } }"
        >
          <v-icon color="white">mdi-medical-bag</v-icon>&nbsp; Liste des
          produits
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FournisseurFicheInfo from "@/components/FournisseurFicheInfo.vue";
import FournisseursService from "@/services/FournisseursService";

export default {
  name: "FournisseurView",
  components: {
    FournisseurFicheInfo,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      fournisseur: null,
      panels: [0, 1, 2, 3, 4],
    };
  },
  computed: {
    logoPath() {
      return process.env.VUE_APP_PATH_TO_FRN_LOGO;
    },
  },
  created() {
    FournisseursService.getFournisseur(this.id)
      .then((res) => {
        this.fournisseur = res.data;

        this.$store.dispatch("fetchResultats", {
          type: 2,
          recherche: this.fournisseur.nom,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style scoped>
.v-card {
  font-size: 0.9em;
}

#ficheFrn >>> .v-expansion-panel-header__icon > .v-icon {
  color: #fff;
}

#ficheFrn >>> .v-expansion-panel-content__wrap {
  padding: 0 12px;
}

h3 {
  font-size: 1.05em;
}

li {
  list-style: none;
}
</style>
